;(function($) {
  $(document).on('click', '[data-duplicate-row]', function(e) {
    e.preventDefault()
    e.stopPropagation()
    var $button = $(this)
    var rowSelector = $button.data('duplicate-row')
    var $ghostRowTemplate = $(rowSelector)
    var ghostRowTemplate = $ghostRowTemplate.html()
    if (!ghostRowTemplate) {
      console.error('Template not found with selector', rowSelector)
      return
    }
    var parentSelector = $button.data('duplicate-row-target')
    var $parent = $button.parent()
    if (parentSelector) {
      $parent = $parent.nearest(parentSelector)
    }

    var newRowCount = 1 + ($parent.data('new-row-counter') || 0)
    $parent.data('new-row-counter', newRowCount)
    var id = 'new-' + newRowCount
    ghostRowTemplate = ghostRowTemplate.split('{id}').join(id)
    var $newRow = $(ghostRowTemplate).removeClass('ghost-row')
    $parent.append($newRow)
    $newRow.trigger('bless')
    if (newRowCount > 0) $('.add-program-btn-holder').removeClass('display-none')
  })

  $(document).on('click', '[data-remove-row]', function(e) {
    var $elm = $(this)
    var selector = $elm.data('remove-row')
    var $target = $elm.parent()
    if (selector) {
      $target = $elm.closest(selector).first()
    }

    $target.remove()
  })

  $(document).on('bless', function(evt) {
    evt.stopPropagation()
    var $elm = $(evt.target)
    $elm
      .find('input[data-complex-part], select[data-complex-part]')
      .resolveComplexName()
  })

  $.fn.resolveComplexName = function() {
    this.each(function() {
      var $elm = $(this)
      if ($elm.is('input, select')) {
        var part = $elm.data('complex-part')
        $elm.parents('[data-complex-part]').each(function(index, elm) {
          part = $(elm).data('complex-part') + part
        })
        $elm.attr('name', part)
      }
    })
    return this
  }

  $.fn.nearest = function(selector) {
    var result = false
    this.parents().each(function() {
      if (result) {
        return
      }
      var relevantOffspring = $(this).find(selector)
      if (relevantOffspring.length > 0) {
        result = relevantOffspring.first()
      }
    })
    return result
  }
})(jQuery)
